import { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { getDoc, doc, updateDoc } from 'firebase/firestore'
import { toast } from 'react-toastify'

import { db } from '../firebase'
import Layout from '../components/layout'
import MainTitle from '../components/main_title'
import Spinner from '../components/spinner'
import { convertTime } from '../helpers/datetime_helper'
import { getIconBySentiment } from '../components/icons'
import { IJournal, emptyJournal } from '../types/journal'

function EditJournal() {
  const { id } = useParams()
  const [sentiment, setSentiment] = useState('unknown')
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate() // Navigation

  const [journal, setJournal] = useState<IJournal>(emptyJournal)

  useEffect(() => {
    const fetchJournal = async () => {
      if (id) {
        const docRef = doc(db, 'journals', id)
        const docSnap = await getDoc(docRef)

        if (docSnap.exists()) {
          const docInfo = docSnap.data()
          const data: IJournal = {
            id: docSnap.id,
            title: docInfo.title,
            date: docInfo.date,
            content: docInfo.content,
            sentiment: docInfo.sentiment
          }
          setJournal(data)
          setSentiment(data.sentiment)
          setLoading(false)
        }
      }
    }

    fetchJournal()
  }, [id])

  async function updateJournal() {
    if (id) {
      const journalRef = doc(db, 'journals', id)
      await updateDoc(journalRef, { ...journal })
      navigate('/journals')
      toast.success('Successfully edited the current journal')
    }
  }

  function querySentiment() {
    const url = 'https://peacemindapi.lev99.com/journal-sentiment-analysis2'
    // const url = 'http://127.0.0.1:5000/journal-sentiment-analysis/'
    setSentiment('loading')
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-type': 'application/json'
      },
      body: JSON.stringify(journal.content)
    })
      .then((response) => response.json())
      .then((data) => {
        setSentiment(data)
      })
      .catch((err) => {
        console.log(JSON.stringify(err))
      })
  }

  if (loading) {
    return <Spinner />
  }

  return (
    <Layout>
      <MainTitle title="Edit Journal:" />
      <input
        id="title"
        placeholder="title"
        className="my-1 mr-4 w-full rounded-2xl bg-primary py-2 px-3"
        value={journal.title}
        onChange={(e) => setJournal({ ...journal, title: e.target.value })}
      />
      <input
        id="date"
        placeholder="date"
        className="my-1 mr-4 w-full rounded-2xl bg-primary py-2 px-3"
        value={convertTime(journal.date)}
        onChange={(e) =>
          setJournal({ ...journal, date: new Date(e.target.value) })
        }
      />
      <textarea
        id="content"
        placeholder="content"
        rows={13}
        className="my-2 mr-4 w-full rounded-2xl bg-primary py-2 px-3 pb-24"
        value={journal.content}
        onChange={(e) => setJournal({ ...journal, content: e.target.value })}
      />

      <div className="flex justify-between">
        <button
          className="rounded-2xl bg-secondary py-2 px-6 text-white hover:bg-tertiary"
          onClick={querySentiment}
        >
          Check Sentiment
        </button>
        <div className="mt-4 flex w-full justify-center">
          {getIconBySentiment(sentiment, 72)}
        </div>
        <button
          className="w-40 rounded-2xl bg-secondary py-2 px-6 text-white hover:bg-tertiary"
          onClick={updateJournal}
        >
          Save
        </button>
      </div>
    </Layout>
  )
}

export default EditJournal
